import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import * as React from 'react';
import * as cx from 'classnames';

import { IControlLinkButtonProps } from './types';
import { SIZE_TO_CLASS } from './constants';
import * as styles from './styles.css';

export function ControlLinkButton({
  children,
  className,
  size = 'M',
  rounded,
  tooltip,
  ...sharedProps
}: IControlLinkButtonProps) {
  const classNames = cx(
    styles['container'],
    SIZE_TO_CLASS[size],
    {
      [styles['rounded']]: rounded,
    },
    className,
  );

  if (!tooltip) {
    return (
      <a {...sharedProps} className={classNames}>
        {children}
      </a>
    );
  }

  return (
    <TooltipDesktop placement="left" theme="black" title={tooltip}>
      <a {...sharedProps} className={classNames}>
        {children}
      </a>
    </TooltipDesktop>
  );
}
